<template>
	<view class="apply-condition p30 bg-white" v-if="!loadding">
		<view class="pb60 d-c-c gray3 f36 fb">
			{{words.apply.words.not_pass.value||''}}
		</view>
		<view class="f28 tc">
			<view>{{checkData.text}}达到<text class="f30 red">{{checkData.target}}{{checkData.unit}}</text>可申请成为{{ words.index.words.region.value }}</view>
			<view class="pt10">您当前的{{checkData.text}}为<text class="red">{{checkData.now_target}}{{checkData.unit}}</text></view>
		</view>
		<view class="info f28 pt60 pb60 mt60 border-t">
			<view class="d-s-c">
				<view>代理区域</view>
				<button @click="resetChoose" class="btn btn-red-border ml20">去修改</button>
			</view>
			<view class="pt20">
				<text class="gray6">代理级别：</text>
				<text>{{checkData.level_name}}</text>
			</view>
			<view class="pt20">
				<text class="gray6">代理区域：</text>
				<text>{{checkData.province_name}}</text>
				<text v-if="checkData.region_level>1">-{{checkData.city_name}}</text>
				<text v-if="checkData.region_level>2">-{{checkData.area_name}}</text>
			</view>
		</view>
		<view class="p30">
			<button type="primary" class="btn-gcred" @click="gotoShop">{{ words.apply.words.goto_mall.value }}</button>
		</view>
	</view>
</template>

<script>
	export default{
		data(){
			return {
				
			}
		},
		props: ['checkData','words'],
		onLoad() {
		
		},
		mounted() {
		
		},
		methods:{
			resetChoose() {
				this.$emit("reset",false);
			},
			
			/*去商城逛逛*/
			gotoShop() {
				this.gotoPage('pages/index/index')
			},
		}
	}
</script>

<style>
	.apply-condition {
		margin-top: 292rpx;
		position: relative;
	}
	.apply-condition .btn-red-border {
		padding: 0 12rpx;
		font-size: 24rpx;
		line-height: normal;
		border-radius: 60rpx;
	}
	.apply-condition .btn-gcred {
	    width: 600rpx;
	    height: 88rpx;
	    line-height: 88rpx;
	    border-radius: 44rpx;
	    box-shadow: 0 8rpx 16rpx 0 rgba(226, 35, 26, 0.6);
	}
</style>

